module.exports = __webpack_public_path__ + "img/Roboto-Medium-webfont.a5692169.svg";